import { getTimeZoneAbbreviation } from './timezoneUtils'

/**
 * ブラウザのデフォルトのタイムゾーンを取得する
 * @returns IANA Time Zone Database name
 * ex) Asia/Tokyo
 */
export const browserTimeZone = () =>
  Intl.DateTimeFormat().resolvedOptions().timeZone

export const timeZoneLabel = () => {
  const tz = browserTimeZone()
  return getTimeZoneAbbreviation(tz)
}
